import React, { type CSSProperties } from 'react';
import styles from './SkeletonBox.module.css';

interface SkeletonBoxProps extends React.HTMLAttributes<HTMLDivElement> {
  width?: string;
  height?: string;
}

export function SkeletonBox({
  width,
  height,
  className,
  style,
  ...props
}: SkeletonBoxProps) {
  const cssVars = {
    ...(width ? { '--skeleton-width': width } : {}),
    ...(height ? { '--skeleton-height': height } : {}),
    ...style,
  } as CSSProperties;

  return (
    <div
      {...props}
      className={[styles.skeletonBox, className].filter(Boolean).join(' ')}
      style={cssVars}
    />
  );
}
